module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-xs-12 hydroware-container-heading"
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._t("header_title", [(_vm.title !== null) ? _c('div', {
    staticStyle: {
      "font-size": "2em"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.title) + "\n            ")]) : _vm._e()])], 2), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._t("after_header_title", [_vm._v("\n            after the title\n          ")])], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 hydroware-container-body"
  }, [_c('el-checkbox-group', _vm._g(_vm._b({
    attrs: {
      "disabled": _vm.disableChoices
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, 'el-checkbox-group', [_vm.$attrs, _vm.$props], false), _vm.$listeners), _vm._l((_vm.choices), function(oneCheckbox) {
    return _c('el-checkbox', {
      key: oneCheckbox[_vm.varForKey],
      staticClass: "hydroware-checkbox",
      attrs: {
        "label": oneCheckbox[_vm.varForLabel],
        "value": oneCheckbox
      }
    }, [_vm._v("\n          " + _vm._s(oneCheckbox[_vm.varForDisplayedValue]) + "\n      ")])
  }), 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27ac4026"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/hydroware-checkbox-group.vue
// module id = 788
// module chunks = 1